import { useRef, useState } from 'react';
import { Button, Portal } from '@nazka/nazka.mapframe.components';
import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import CompanyIdentificationNumberInput from '@App/components/CompanyIdentificationNumberInput/CompanyIdentificationNumberInput';

import { useOnClickOutside } from '@services/hooks.service';
import { addCompaniesToUser } from '@services/user.service';

import queryClient from '@App/app.query-client';

import './admin-add-company.styl';

function AdminAddCompany({
  onClose,
}) {
  const [companies, setCompanies] = useState([]);

  const contentRef = useRef();

  useOnClickOutside(contentRef, onClose);

  const addCompaniesToUserMutation = useMutation({
    mutationFn: () => addCompaniesToUser(companies.map(c => c.id)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['user', 'companies'] });
      toast.success(`De onderming${companies.length === 1 ? 'en' : ''} ${companies.length === 1 ? 'is' : 'zijn'} toegevoegd`);
      onClose();
    },
    onError: () => {
      toast.error('Er ging helaas iets mis bij het toevoegen');
    },
  });

  return (
    <Portal>
      <div className="admin-add-company__background">
        <div className="admin-add-company" ref={contentRef}>
          <h3 className="admin-add-company__title">
            Voeg een ondernemingsnummer toe
            <Button
              icon={faClose}
              layout="ghost"
              hover={false}
              className="admin-add-company__title__close"
              onClick={onClose}
            />
          </h3>
          <CompanyIdentificationNumberInput
            className="register-form__field"
            companies={companies}
            onChange={setCompanies}
          />
          <Button
            className="admin-add-company__confirm"
            onClick={() => addCompaniesToUserMutation.mutate()}
            isLoading={addCompaniesToUserMutation.isPending}
            disabled={!companies.length}
          >
            Sla op
          </Button>
        </div>
      </div>
    </Portal>
  );
}

export default AdminAddCompany;